import { trackEvent } from "./telemetryClient";
import { TELEMETRY_CATEGORIES, TELEMETRY_EVENTS } from "./telemetryEvents";

function buildDedupeKey(toolId, eventName, payload = {}) {
  const parts = [
    toolId,
    payload.operation ?? "generate",
    payload.mode ?? "",
    payload.sectionId ?? "",
    payload.targetId ?? "",
  ].filter(Boolean);
  return `${eventName}:${parts.join(":")}`;
}

export function trackGenerationStarted(toolId, payload = {}) {
  return trackEvent(
    TELEMETRY_EVENTS.GENERATION_STARTED,
    {
      operation: payload.operation ?? "generate",
      ...payload,
    },
    {
      category: TELEMETRY_CATEGORIES.PERFORMANCE,
      context: { toolId },
      dedupeKey: buildDedupeKey(toolId, "started", payload),
    },
  );
}

export function trackGenerationCompleted(toolId, payload = {}) {
  const event = trackEvent(
    TELEMETRY_EVENTS.GENERATION_COMPLETED,
    {
      operation: payload.operation ?? "generate",
      mode: payload.mode ?? "initial",
      ...payload,
    },
    {
      category: TELEMETRY_CATEGORIES.PERFORMANCE,
      context: { toolId },
      dedupeKey: buildDedupeKey(toolId, "completed", payload),
    },
  );

  if (payload.mode === "regenerate") {
    trackEvent(
      TELEMETRY_EVENTS.GENERATION_REGENERATED,
      {
        operation: payload.operation ?? "regenerate",
        ...payload,
      },
      {
        category: TELEMETRY_CATEGORIES.INTERACTION,
        context: { toolId },
        dedupeKey: buildDedupeKey(toolId, "regenerated", payload),
      },
    );
  }

  return event;
}

export function trackGenerationFailed(toolId, payload = {}) {
  return trackEvent(
    TELEMETRY_EVENTS.GENERATION_FAILED,
    {
      operation: payload.operation ?? "generate",
      mode: payload.mode ?? "initial",
      ...payload,
    },
    {
      category: TELEMETRY_CATEGORIES.ERROR,
      context: { toolId },
      dedupeKey: buildDedupeKey(toolId, "failed", payload),
    },
  );
}

export function trackGenerationVersionRestored(toolId, payload = {}) {
  return trackEvent(
    TELEMETRY_EVENTS.GENERATION_VERSION_RESTORED,
    payload,
    {
      category: TELEMETRY_CATEGORIES.INTERACTION,
      context: { toolId },
      dedupeKey: `${toolId}:version-restored:${payload.versionCount ?? ""}`,
    },
  );
}
